import { css } from '@emotion/react';

export default $ => css`
  .media {
    display: flex;
    align-items: flex-start;
  }

  .media-body {
    flex: 1;
  }
`;
